<div class="games-running-modal-container d-flex flex-column" style="height: 350px;">
    <div class="modal-header">
        <span class="modal-title lato-bold" style="font-size: 18px"cvLocalizedText langSection="Games" langKey="Set_Metric_Goal">Set Metric Goal</span>
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body flex-fill p-1">
        <div class="d-flex flex-column">
            <div class="d-flex flex-row">
                <div class="py-1 align-items-center text-body my-2 mr-3 text-nowrap">
                    <button type="button" class="btn btn-secondary" (click)="launchMetricSelector()" cvLocalizedText langSection="Rules" langKey="Metrics">Metrics</button>
                </div>
                <div class="d-flex align-items-center justify-content-center glaeConfigureMetricPill rounded-pill text-body px-3 py-2 m-2 text-nowrap" [hidden]="!(metricSelected.length > 0)">
                    <p class="color-panther m-0 font-size-12">{{((metricSelected.length == 0) ? getLocalizedText("None_Selected", "None Selected") : metricSelected[0].abbrev)}}</p>
                </div>
            </div>
            <div style="color:darkred">{{validatorMessage}}</div>
            <div class="d-flex flex-fill pt-3 flex-column">
                <div class="flex-fill">
                    <span cvLocalizedText langSection="Wallboard_Management" langKey="Target">Target</span> 
                    <span class="ml-1">({{((metricSelected[0].direction == 0) ? getLocalizedText("Less_Than", "Less Than") : getLocalizedText("Greater_Than", "Greater Than"))}}):</span></div>
                <div class="d-flex flex-column pt-2">
                    <div class="d-flex align-items-center flex-fill ">
                        <div class="input-group">
                            <input class="form-control col-3 no-spinner" type="text" [ngModel]="customTarget.Target" (ngModelChange)="customTarget.Target = $event" (blur)="formatOnBlur(customTarget.Target)" (keypress)="validate($event)"
                                maxlength="10" name="number">
                            <div class="input-group-append" *ngIf="metricTypeSign != null && metricTypeSign.length > 0">
                                <span class="input-group-text py-0">{{metricTypeSign}}</span>
                            </div>
                        </div>
                    </div>
                    <div style="color:darkred">{{targetValidatorMessage}}</div>
                </div>
            </div>
            <div class="d-flex flex-row font-size-12">
                <p class="pt-2 color-whaleTail">{{targetMessage}}</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-text" (click)="cancel()" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveMetricTarget()" cvLocalizedText langSection="Common" langKey="Save_Button">Save</button>
    </div>
</div>